//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import ecommerceIntegrationsConnectedTemplate from '@legacy-components/ecommerce-integrations/ecommerce-integrations-connected.html';

(function() {
  angular.module('curalate').component('ecommerceIntegrationsConnected', {
    template: ecommerceIntegrationsConnectedTemplate,
  });
})();
